export default __webpack_public_path__ + "static/media/add_photo.9e4f05f7.svg";